exports = module.exports = require("../../../../../../../../vendor/justbetter/magento2mix/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"gridGapColumn": "15px",
	"gridGapRow": "30px",
	"xs": "460px",
	"sm": "768px",
	"md": "992px",
	"lg": "1200px",
	"xl": "1680px",
	"hiddenMobileMenu": "992px",
	"mainSlidesXs": "1",
	"mainSlidesSm": "2",
	"mainSlidesMd": "3",
	"mainSlidesLg": "4",
	"mainSlidesXl": "5",
	"mainSlidesSpaceBetweenSmall": "0",
	"mainSlidesSpaceBetween": "20px",
	"mainSlideLoop": "1",
	"bundelSlidesXs": "1",
	"bundelSlidesSm": "2",
	"bundelSlidesMd": "4",
	"bundelSlidesLg": "4",
	"bundelSlidesXl": "4",
	"bundelSlidesSpaceBetween": "0",
	"upsellSlidesXs": "1",
	"upsellSlidesSm": "2",
	"upsellSlidesMd": "3",
	"upsellSlidesLg": "4",
	"upsellSlidesXl": "5",
	"upsellSlidesSpaceBetween": "0",
	"upsellLoop": "1",
	"crossellSlidesXs": "1",
	"crossellSlidesSm": "2",
	"crossellSlidesMd": "3",
	"crossellSlidesLg": "4",
	"crossellSlidesXl": "5",
	"crossellSlidesSpaceBetween": "0",
	"crossellLoop": "1",
	"relatedSlidesXs": "1",
	"relatedSlidesSm": "2",
	"relatedSlidesMd": "3",
	"relatedSlidesLg": "4",
	"relatedSlidesXl": "5",
	"relatedSlidesSpaceBetween": "0",
	"relatedLoop": "1",
	"galleryThumbsUseControl": "false",
	"galleryThumbsNavButtons": "true",
	"galleryThumbsFreeMode": "true",
	"galleryThumbsCenteredSlides": "false",
	"galleryThumbsDirection": "horizontal",
	"galleryThumbsSpaceBetween": "10",
	"galleryThumbsSlidesPerView": "4",
	"galleryThumbsWatchSlidesProgress": "1",
	"galleryThumbsLoop": "0",
	"galleryTopLoop": "1"
};